import * as React from "react";

const TableLoadingIndicatorContext = React.createContext(null);

export function TableLoadingIndicatorProvider({ indicator = null, children }) {
    return (
        <TableLoadingIndicatorContext.Provider value={indicator}>
            {children}
        </TableLoadingIndicatorContext.Provider>
    );
}

export function useTableLoadingIndicator() {
    return React.useContext(TableLoadingIndicatorContext);
}
